var resolve = require("./resolve");
var request = require("./request");
var Promise = require("bluebird");
var config = require("./config");

exports.Crop = function(image) {
  return request.post(resolve(config.url(), "/image/crop"), image).promise();
};
